import React from 'react';
import { VectorLayer } from '@agissc/ktag-map';

import styleQueryResults from '../../assets/geostyle/attributeSearch-result-style.json';
import styleQuerySelected from '../../assets/geostyle/attributeSearch-selected-style.json';
import useAppState from '../../AppStore';
import { useAttributeSearchData } from '../hooks/useAttributeSearch';

const AttributeSearchResultLayer = () => {
  const topicLayerSettings = useAppState((state) => state.topicLayerSettings);
  const attributeSearch = useAppState((state) => state.attributeSearch);
  const currentAttributeSearchTopicId = useAppState(
    (state) => state.currentAttributeSearchTopicId,
  );

  const attributeQueryData = useAttributeSearchData(currentAttributeSearchTopicId);

  if (
    !currentAttributeSearchTopicId ||
    attributeQueryData.length === 0 ||
    !topicLayerSettings[currentAttributeSearchTopicId].isVisible ||
    !attributeSearch
  ) {
    return null;
  }

  const searchParams = attributeSearch[currentAttributeSearchTopicId];
  const { selectedFeatureId, highlightedFeatureId } = searchParams;
  const featureId = highlightedFeatureId || selectedFeatureId;
  const selectedFeature = attributeQueryData.features.find(
    (feature: any) => feature.id === featureId,
  );

  return (
    <>
      {selectedFeature && (
        <VectorLayer
          features={selectedFeature}
          style={styleQuerySelected as any}
          isVisible
          opacity={1}
          zindex={10001}
        />
      )}
      <VectorLayer
        features={attributeQueryData}
        style={styleQueryResults as any}
        isVisible
        opacity={1}
        zindex={10000}
      />
    </>
  );
};

export default AttributeSearchResultLayer;
